
const WEB_CONTEXT = '/bigdata/';

const BASE_URL = '/web';

const constConfig = {
  privKey: 'MIICXQIBAAKBgQC1Rs1eJsIJpSWMB4yIuuX2pDWBSDl1nZN6E2ghO1WQSf9da/Be7YcOGieHtRJBF0dnvMLz9aGW57Yfs+V8fl3ku7YIVF2rKMNZlcae9lf4Fq9LAdZP07FUOjLsvCFnlz81MtzrxDtB14z7c8d2O+urjRK9QjWIqAE6TiJo9oeEfwIDAQABAoGAO+/WFWxROekt2ffhApBxWrR+sGlV/kqEqZdjFaHNr7CXy6bVyj1VK1eAfIFlMLpmtKkX+JvdusyQTjkoBpqtplWhZUoT9fyQ7Ql8xAomCQDNbGKM8OnL7+fzOfsT4mISUvUhgAkZlbLCNa7Xv+GWISIno6JgnUCL/gA22dbhJ+ECQQDlbJpwWa6tjHGgpaLEnd2bBdIjz3J2rClzsh03hBR7llRRcSa0gXz2KIo6anO5j0pvxiPE05WJ+uleXG+NHrdRAkEAykZq6G5cGTequFj6URq3q/cBhXzt8RCJKOCx3GsrFRUqj063hvVKe3AJ3J4PwrxfULqOVklqiE0xwblC+z4qzwJBAJ2y4RWJD8DLYO+D6zYrLUB559AlsBBSlsuoCt02NL4evyacGHbK6xJpG1q8AX/zNr9N+xg4N/n4NqFd+G+QRYECQQCzafZVp93E+F1TGokc+0fDHlqZHpCm6/Xc7kCUs/IIxzdy2W1sJZIlHuGAcCqmnhMlNfQekQwPTfk+Tacd1qx9AkBx1Gp+vhEwW7vrmVeYpJAXHdbN68GscmGajFzR20t3JnuqXh7rli0PP3cpkLfBjNlDlCunpD0/P3qb5ArMpOBK',
  pubKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC1Rs1eJsIJpSWMB4yIuuX2pDWBSDl1nZN6E2ghO1WQSf9da/Be7YcOGieHtRJBF0dnvMLz9aGW57Yfs+V8fl3ku7YIVF2rKMNZlcae9lf4Fq9LAdZP07FUOjLsvCFnlz81MtzrxDtB14z7c8d2O+urjRK9QjWIqAE6TiJo9oeEfwIDAQAB',
  indexPage: WEB_CONTEXT,
  webContext: WEB_CONTEXT,
  axiosBaseURL: BASE_URL,
  igonreErrorURL: ['/api/logout.do', '/api/common/operateToken.do'],
  axiosWithCredentials: true,
  axiosTimeout: 5000,
  tokenURL: '/api/common/operateToken.do',
  tokenName: 'lbgj_web_user_token',
  persistName: 'lbgj_vuex_key',
  tokenHeaderName: 'JWT_TOKEN',
  xsrfCookieName: 'U_XSRF_TOKEN',
  xsrfHeaderName: 'U_OPT_TOKEN',
};

export default constConfig;
